// 동의서 관리 Mock 데이터

import type { ConsentTemplate, SignedConsent, MockCustomer } from './types';

// 샘플 서명 이미지 (base64)
const SAMPLE_SIGNATURE_URL = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMDAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCAyMDAgODAiPjxwYXRoIGQ9Ik0xMCA1MEMzMCAzMCA1MCA0MCA3MCAzMEM5MCAyMCAxMTAgNDAgMTMwIDMwQzE1MCAyMCAxNzAgNDAgMTkwIDM1IiBmaWxsPSJub25lIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMiIvPjwvc3ZnPg==';

// 샘플 이미지 URL (placeholder)
const SAMPLE_IMAGE_URL = 'https://via.placeholder.com/400x600/f3f4f6/666666?text=동의서+양식';

// 초기 템플릿 데이터
export const initialTemplates: ConsentTemplate[] = [
    {
        id: 1,
        name: '위탁 돌봄 동의서',
        content: `<h2>반려동물 위탁 돌봄 동의서</h2>
<p>본 동의서는 반려동물 위탁 돌봄 서비스 이용에 관한 동의서입니다.</p>
<ol>
<li>위탁 기간 동안 반려동물의 건강 및 안전에 최선을 다하겠습니다.</li>
<li>응급 상황 발생 시 보호자에게 즉시 연락하며, 연락이 닿지 않을 경우 응급 조치를 취할 수 있습니다.</li>
<li>위탁 기간 중 발생하는 사료, 간식, 의료비 등은 별도 청구될 수 있습니다.</li>
<li>전염성 질환이 있는 반려동물은 위탁이 제한될 수 있습니다.</li>
</ol>
<p><strong>위 내용을 확인하였으며, 동의합니다.</strong></p>`,
        questions: [
            {
                id: 'q1',
                name: '반려동물 건강상태',
                type: 'single',
                options: [
                    { id: 'o1', value: '양호' },
                    { id: 'o2', value: '주의 필요' },
                    { id: 'o3', value: '치료 중' },
                ],
                isRequired: true,
            },
            {
                id: 'q2',
                name: '특이사항 (알레르기, 질환 등)',
                type: 'text',
                options: [],
                isRequired: false,
            },
        ],
        isMandatory: true,
        isFileUploaded: false,
        createdAt: '2024-01-15T09:00:00Z',
        updatedAt: '2024-03-01T10:00:00Z',
        currentVersion: 2,
        activeVersion: 2,
        versionHistory: [
            {
                version: 1,
                content: `<h2>위탁 돌봄 동의서</h2><p>반려동물 위탁 서비스 이용 동의서입니다.</p>`,
                questions: [],
                createdAt: '2024-01-15T09:00:00Z',
                createdBy: '관리자',
                changeNote: '최초 생성',
            },
            {
                version: 2,
                content: `<h2>반려동물 위탁 돌봄 동의서</h2>
<p>본 동의서는 반려동물 위탁 돌봄 서비스 이용에 관한 동의서입니다.</p>
<ol>
<li>위탁 기간 동안 반려동물의 건강 및 안전에 최선을 다하겠습니다.</li>
<li>응급 상황 발생 시 보호자에게 즉시 연락하며, 연락이 닿지 않을 경우 응급 조치를 취할 수 있습니다.</li>
<li>위탁 기간 중 발생하는 사료, 간식, 의료비 등은 별도 청구될 수 있습니다.</li>
<li>전염성 질환이 있는 반려동물은 위탁이 제한될 수 있습니다.</li>
</ol>
<p><strong>위 내용을 확인하였으며, 동의합니다.</strong></p>`,
                questions: [
                    {
                        id: 'q1',
                        name: '반려동물 건강상태',
                        type: 'single',
                        options: [
                            { id: 'o1', value: '양호' },
                            { id: 'o2', value: '주의 필요' },
                            { id: 'o3', value: '치료 중' },
                        ],
                        isRequired: true,
                    },
                    {
                        id: 'q2',
                        name: '특이사항 (알레르기, 질환 등)',
                        type: 'text',
                        options: [],
                        isRequired: false,
                    },
                ],
                createdAt: '2024-03-01T10:00:00Z',
                createdBy: '관리자',
                changeNote: '응급 조항 추가 및 문구 수정',
            },
        ],
    },
    {
        id: 2,
        name: '응급 치료 동의서',
        content: `<h2>응급 치료 동의서</h2>
<p>본 동의서는 반려동물 응급 치료에 관한 동의서입니다.</p>
<ol>
<li>위탁 기간 중 응급 상황 발생 시, 보호자 연락이 불가능한 경우 응급 치료를 진행할 수 있습니다.</li>
<li>응급 치료에 소요되는 비용은 보호자가 부담합니다.</li>
<li>치료 내역은 위탁 종료 시 상세히 안내드립니다.</li>
</ol>
<p><strong>위 내용을 확인하였으며, 동의합니다.</strong></p>`,
        questions: [
            {
                id: 'q3',
                name: '응급 연락처 (보호자 외)',
                type: 'text',
                options: [],
                isRequired: true,
            },
        ],
        isMandatory: true,
        isFileUploaded: false,
        createdAt: '2024-01-10T09:00:00Z',
        updatedAt: '2024-01-12T14:30:00Z',
        currentVersion: 1,
        activeVersion: 1,
        versionHistory: [
            {
                version: 1,
                content: `<h2>응급 치료 동의서</h2>
<p>본 동의서는 반려동물 응급 치료에 관한 동의서입니다.</p>
<ol>
<li>위탁 기간 중 응급 상황 발생 시, 보호자 연락이 불가능한 경우 응급 치료를 진행할 수 있습니다.</li>
<li>응급 치료에 소요되는 비용은 보호자가 부담합니다.</li>
<li>치료 내역은 위탁 종료 시 상세히 안내드립니다.</li>
</ol>
<p><strong>위 내용을 확인하였으며, 동의합니다.</strong></p>`,
                questions: [
                    {
                        id: 'q3',
                        name: '응급 연락처 (보호자 외)',
                        type: 'text',
                        options: [],
                        isRequired: true,
                    },
                ],
                createdAt: '2024-01-10T09:00:00Z',
                createdBy: '관리자',
                changeNote: '최초 생성',
            },
        ],
    },
    {
        id: 3,
        name: '개인정보 수집 동의서',
        content: '',
        questions: [],
        isMandatory: true,
        isFileUploaded: true,
        fileUrl: '/assets/consent/privacy-policy.pdf',
        fileName: '개인정보수집동의서.pdf',
        fileType: 'pdf',
        hasSignatureBox: true,
        createdAt: '2024-01-05T09:00:00Z',
        updatedAt: '2024-01-05T09:00:00Z',
        currentVersion: 1,
        activeVersion: 1,
    },
    {
        id: 4,
        name: '호텔 이용 동의서',
        content: '',
        questions: [],
        isMandatory: false,
        isFileUploaded: true,
        fileUrl: SAMPLE_IMAGE_URL,
        fileName: '호텔이용동의서.png',
        fileType: 'image',
        hasSignatureBox: true,
        createdAt: '2024-01-08T09:00:00Z',
        updatedAt: '2024-01-08T09:00:00Z',
        currentVersion: 1,
        activeVersion: 1,
    },
    {
        id: 5,
        name: '미용 서비스 동의서',
        content: `<h2>미용 서비스 동의서</h2>
<p>반려동물 미용 서비스 이용에 관한 동의서입니다.</p>
<ul>
<li>미용 중 예상치 못한 피부 문제 발견 시 보호자에게 연락합니다.</li>
<li>미용 후 알러지 반응이 있을 경우 즉시 알려주세요.</li>
<li>털 상태에 따라 추가 비용이 발생할 수 있습니다.</li>
</ul>`,
        questions: [],
        isMandatory: false,
        isFileUploaded: false,
        createdAt: '2024-01-02T09:00:00Z',
        updatedAt: '2024-01-02T09:00:00Z',
        currentVersion: 1,
        activeVersion: 1,
    },
];

// 초기 서명된 동의서 데이터
export const initialSignedConsents: SignedConsent[] = [
    {
        id: '1',
        templateId: '1',
        templateName: '위탁 돌봄 동의서',
        templateVersion: 1, // 이전 버전으로 서명
        customerName: '김철수',
        customerPhone: '010-1234-5678',
        petName: '초코',
        petSpecies: '강아지',
        petBreed: '말티즈',
        signedAt: '2024-01-20T10:30:00Z',
        signatureImageUrl: SAMPLE_SIGNATURE_URL,
        signedContent: `<h2>위탁 돌봄 동의서</h2><p>반려동물 위탁 서비스 이용 동의서입니다.</p>`,
    },
    {
        id: '2',
        templateId: '2',
        templateName: '응급 치료 동의서',
        templateVersion: 1,
        customerName: '김철수',
        customerPhone: '010-1234-5678',
        petName: '초코',
        petSpecies: '강아지',
        petBreed: '말티즈',
        signedAt: '2024-01-18T14:00:00Z',
        signatureImageUrl: SAMPLE_SIGNATURE_URL,
    },
    {
        id: '3',
        templateId: '3',
        templateName: '개인정보 수집 동의서',
        templateVersion: 1,
        customerName: '김철수',
        customerPhone: '010-1234-5678',
        petName: '초코',
        petSpecies: '강아지',
        petBreed: '말티즈',
        signedAt: '2024-01-22T09:00:00Z',
        signatureImageUrl: SAMPLE_SIGNATURE_URL,
    },
    {
        id: '4',
        templateId: '1',
        templateName: '위탁 돌봄 동의서',
        templateVersion: 2, // 최신 버전으로 서명
        customerName: '이영희',
        customerPhone: '010-2345-6789',
        petName: '뽀삐',
        petSpecies: '강아지',
        petBreed: '푸들',
        signedAt: '2024-03-05T14:00:00Z',
        signatureImageUrl: SAMPLE_SIGNATURE_URL,
    },
    {
        id: '5',
        templateId: '4',
        templateName: '호텔 이용 동의서',
        templateVersion: 1,
        customerName: '이영희',
        customerPhone: '010-2345-6789',
        petName: '뽀삐',
        petSpecies: '강아지',
        petBreed: '푸들',
        signedAt: '2024-01-21T11:00:00Z',
        signatureImageUrl: SAMPLE_SIGNATURE_URL,
    },
    {
        id: '6',
        templateId: '2',
        templateName: '응급 치료 동의서',
        templateVersion: 1,
        customerName: '박민수',
        customerPhone: '010-3456-7890',
        petName: '몽이',
        petSpecies: '고양이',
        petBreed: '코리안숏헤어',
        signedAt: '2024-01-18T09:15:00Z',
        signatureImageUrl: SAMPLE_SIGNATURE_URL,
    },
    {
        id: '7',
        templateId: '1',
        templateName: '위탁 돌봄 동의서',
        templateVersion: 1, // 이전 버전으로 서명
        customerName: '박민수',
        customerPhone: '010-3456-7890',
        petName: '나비',
        petSpecies: '고양이',
        petBreed: '러시안블루',
        signedAt: '2024-01-17T11:30:00Z',
        signatureImageUrl: SAMPLE_SIGNATURE_URL,
        signedContent: `<h2>위탁 돌봄 동의서</h2><p>반려동물 위탁 서비스 이용 동의서입니다.</p>`,
    },
    {
        id: '8',
        templateId: '3',
        templateName: '개인정보 수집 동의서',
        templateVersion: 1,
        customerName: '박민수',
        customerPhone: '010-3456-7890',
        petName: '몽이',
        petSpecies: '고양이',
        petBreed: '코리안숏헤어',
        signedAt: '2024-01-23T15:30:00Z',
        signatureImageUrl: SAMPLE_SIGNATURE_URL,
    },
];

// 고객 Mock 데이터
export const mockCustomers: MockCustomer[] = [
    {
        id: 'c1',
        name: '김철수',
        phone: '010-1234-5678',
        pets: [
            { id: 'p1', name: '초코', species: '강아지', breed: '푸들' },
            { id: 'p2', name: '뭉치', species: '강아지', breed: '말티즈' },
        ],
    },
    {
        id: 'c2',
        name: '이영희',
        phone: '010-2345-6789',
        pets: [
            { id: 'p3', name: '뽀삐', species: '강아지', breed: '비숑' },
        ],
    },
    {
        id: 'c3',
        name: '박민수',
        phone: '010-3456-7890',
        pets: [
            { id: 'p4', name: '몽이', species: '고양이', breed: '페르시안' },
            { id: 'p5', name: '냥이', species: '고양이', breed: '코리안숏헤어' },
        ],
    },
];
